<!-- Carousel Start -->
<app-public-header></app-public-header>
<mdb-carousel [controls]="true" [indicators]="true" [animation]="'fade'" >
    <mdb-carousel-item style="z-index: -1;">
        <img src="../../../assets/img/ccb-accueil-1.jpg" height="540px" class="d-block w-100" alt="Cour des Comptes du Bénin" />

    </mdb-carousel-item>

    <mdb-carousel-item style="z-index: -1;">
        <img src="../../../assets/img/ccb-accueil-2.jpg" height="540px" class="d-block w-100" alt="Cour des Comptes du Bénin" />
    </mdb-carousel-item>
    <div class="carousel-caption-container mb-40 ">
        <div class="carousel-caption-content">
            <h1 class="text-white ">
                Cour des Comptes du Bénin
            </h1>
            <p class="mb-5 fs-5 text-white">
                La Cour des Comptes du Bénin est l'organe suprême de contrôle des finances publiques. <br>
                Elle veille à la bonne utilisation des fonds publics et accompagne l'amélioration de la gouvernance publique.
            </p>
            <div class="text-left">
                <a (click)="routerAbout()" id="but" class="btn btn-primary rounded-pill text-white py-3 px-5">
                    En savoir +
                </a>
            </div>
        </div>
    </div>
</mdb-carousel><br><br><br>

<section class="banner">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-12 text-center text-center">
                <h2 style="color: white;">Contrôle et Audit des Finances Publiques</h2>
                <p>La Cour des Comptes du Bénin exerce un contrôle a posteriori sur la gestion des finances publiques.
                    Elle vérifie les comptes des ministères, établissements publics et collectivités territoriales,
                    garantissant la transparence et la bonne gouvernance des deniers publics.
                </p>
                <a style="background-color: white; color: black;" routerLink="/apropos" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>
            
        </div>
    </div>
</section>

<!-- Encart 1 Nos Missions -->
<div class="container-fluid feature py-5">
    <div class="container">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <h1 style="font-family: '" class=" mb-4"> <strong> Nos Missions </strong></h1>
        </div>
        <div class="row g-4 justify-content-center">
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-file-list-3-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4">Contrôle des Comptes</p>
                            <p class="mb-0 mt-auto">Vérification et contrôle des comptes publics des ministères et établissements publics.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-file-list-3-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4">Audit Financier</p>
                            <p class="mb-0 mt-auto">Audit des organismes publics et des entreprises du secteur public et national.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-file-list-3-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4">Gouvernance Publique</p>
                            <p class="mb-0 mt-auto">Promotion de la transparence et de la bonne gouvernance dans la gestion des fonds publics.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div><br>
    </div>
</div>
<!-- Encart End -->

<!-- banne 1  Start -->
<section class="banner">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-6 text-center text-md-start">
                <h2 style="color: white;">Qui
                    sommes-nous ?</h2>
                <p>La Cour des Comptes du Bénin est une institution constitutionnelle indépendante, chargée du contrôle des comptes publics...</p>
                <a style="background-color: white; color: black;" href="javascript:void(0);" routerLink="/apropos"
                    class="btn btn-custom">En savoir +</a>
            </div>
            <div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
                <h2 style="color: white;">Mission</h2>
                <p>Assurer le contrôle a posteriori de la gestion des finances publiques et des comptes des administrations publiques...</p>
                <a style="background-color: white; color: black;" href="javascript:void(0);" routerLink="/mission"
                    class="btn btn-custom">En savoir +</a>
            </div>
        </div>
    </div>
</section>
<!-- banne End -->

<!-- Encart 2 Nos Atouts -->
<div class="container-fluid feature py-5">
    <div class="container">
        <div class="section-title mb-5 wow fadeInUp d-flex justify-content-center" data-wow-delay="0.1s">
            <h1 style="font-family: '" class=" mb-4"> <strong>Nos Domaines d'Intervention</strong> </h1>
        </div>
        <div class="row g-4 justify-content-center">
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                <div class="row-cols-1 feature-item p-4">
                    <div class="col-12">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-building-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column">
                            <p id="gras" class="mb-4">Établissements Publics</p>
                            <p class="mb-0">Contrôle des comptes et de la gestion des établissements publics de l'État.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                <div class="row-cols-1 feature-item p-4">
                    <div class="col-12">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-government-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column">
                            <p id="gras" class="mb-4">Collectivités Territoriales</p>
                            <p class="mb-0">Suivi et évaluation de la gestion financière des collectivités décentralisées.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                <div class="row-cols-1 feature-item p-4">
                    <div class="col-12">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-bar-chart-grouped-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column">
                            <p id="gras" class="mb-4">Rapports Publics</p>
                            <p class="mb-0">Publication de rapports annuels et travaux d'information du Parlement et du Gouvernement.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div><br>
        <div class="d-flex justify-content-center">
            <a style="background-color: white; color: black;" routerLink="/metiers" href="javascript:void(0);"
                    class="btn btn-custom">Voir+</a>
        </div>
    </div>
</div>
<!-- Encart End -->

<!-- banne 2  Start -->
<section class="banner">
    <div class="banner-overlay"></div>
    <div class="container">
        <div class="row align-items-center banner-content">
            <div class="col-md-6 text-center text-md-start">
                <h2 style="color: white;">Nos missions </h2>
                <p>Explorez les différentes missions de la Cour des Comptes du Bénin et son rôle dans le contrôle des finances publiques....</p>
                <a style="background-color: white; color: black;" routerLink="/metiers" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>
            <div class="col-md-6 text-center text-md-start mt-4 mt-md-0">
                <h2 style="color: white; font-family: Montserrat;">Nos réalisations </h2>
                <p>Découvrez les travaux et rapports qui contribuent à l'amélioration de la gouvernance publique au Bénin</p>
                <a id="bordure" style="background-color: white; color: black;" routerLink="/realisations" href="javascript:void(0);"
                    class="btn btn-custom">En savoir +</a>
            </div>
        </div>
    </div>
</section>
<!-- banne End -->

<!-- Encart 3 Activites -->
<div class="container-fluid feature py-5">
    <div class="container">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <h1 class="mb-4"><strong>Nos Activités Clés</strong></h1>
        </div>
        <div class="row g-4 justify-content-center">
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-checkbox-circle-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4"><strong>Contrôle des Comptes</strong></p>
                            <p class="mb-0 mt-auto">Examen et certification des comptes rendus financiers des administrations publiques.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-error-warning-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4"><strong>Mission d'Information</strong></p>
                            <p class="mb-0 mt-auto">Enquêtes et investigations sur la gestion des fonds publics à la demande du Parlement.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                <div class="row-cols-1 feature-item p-4 h-100 d-flex flex-column">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="feature-icon mb-4">
                            <div class="p-3 d-inline-flex bg-white rounded">
                                <i class="ri-book-open-line" style="font-size: 60px; color: #364CA0;"></i>
                            </div>
                        </div>
                        <div class="feature-content d-flex flex-column flex-grow-1">
                            <p id="gras" class="mb-4"><strong>Rapports Annuels</strong></p>
                            <p class="mb-0 mt-auto">Publication des rapports annuels et travaux thematic sur les finances publiques.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div><br>
    </div>
</div>
<!-- Encart End -->

<br><br>

<!-- Contact Start -->
<div  style="background-color: rgb(222 224 219 / 46%);" class="container-fluid about " >
    <div class="container ">
        <div class="row g-5 align-items-center">
            <!-- Texte -->
            <div class="col-lg-7 order-lg-1 order-2 wow fadeInLeft" data-wow-delay="0.4s">
                <div class="section-title text-start mb-5">
                    <h1 class="mb-4"> <strong>Nous Contacter</strong> </h1>
                    <p style="color: black;" class="mb-4">La Cour des Comptes du Bénin est à votre disposition pour toute question relative au contrôle des finances publiques, aux rapports d'audit et à la gouvernance publique.</p>
                    <a routerLink="/contact" href="#" class="btn btn-primary rounded-pill text-white py-3 px-5">Contact</a>
                </div>
            </div>
            <!-- Image -->
            <div class="justify-content-center align-items-center col-lg-5 col-12 order-lg-2 order-1 wow fadeInRight p-4"
                data-wow-delay="0.2s">
                <div class="">
                    <img src="../../../assets/img/ccb-batiment.jpg" class="img-fluid rounded" alt="Cour des Comptes du Bénin">
                </div>
            </div>

        </div>
    </div>
</div>
<!-- Contact End -->

<app-public-footer></app-public-footer>
